import { Node_Type } from "./../../ricos-schema/next-schema/index.js";
import { toCamelCase } from "./../to-camel-case.js";
const DATA_FIELD_BY_TYPE = Object.fromEntries(
  Object.values(Node_Type).map((type) => [type, `${toCamelCase(type)}Data`])
);
const getNodeAnimation = (node) => {
  const dataField = DATA_FIELD_BY_TYPE[node.type];
  if (!dataField) {
    return void 0;
  }
  const data = node[dataField];
  return data?.animation;
};
export {
  getNodeAnimation
};
//# sourceMappingURL=get-node-animation.js.map
